export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || 'https://api.pod.nimey-local.de'